<template>
  <div class="flex-1"></div>
</template>

<script>
export default {
  props: {},
}
</script>
